import { Component, Input, OnInit } from '@angular/core';
import { PDFInterface } from '@contracts/interfaces/pdf.interface';
import { PDFService } from '../../services/pdf.service';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {

  @Input() pdf: PDFInterface;

  public pdfSrc: string;

  constructor(private pdfInterface: PDFService) {}

  ngOnInit(): void {
    this.pdfInterface.generatePDF2(this.pdf.file, this.pdf).subscribe((r: any) => {
      console.log(r);
    });
  }
}
